// import type { Breadcrumb } from "@sentry/types";
import { enableSentryTracing } from "@toruslabs/http-helpers";
import log from "loglevel";
import { App } from "vue";
import { Router } from "vue-router";

import appConfig from "../config";

export async function installSentry(app: App, router: Router): Promise<void> {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  const [Sentry, loglevelSentryModule] = await Promise.all([import("@sentry/vue"), import("@toruslabs/loglevel-sentry")]);

  const { default: LoglevelSentryPlugin } = loglevelSentryModule;

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: appConfig.buildEnv,
    release: `wallet-services@${appConfig.appVersion}`,
    integrations: [
      new Sentry.BrowserTracing({
        tracingOrigins: [appConfig.api, appConfig.commonApiHost],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    trackComponents: true,
    ignoreErrors: [],
    sampleRate: Number.parseFloat(appConfig.sentrySampleRate),
    tracesSampleRate: Number.parseFloat(appConfig.sentryTransactionSampleRate),
    normalizeDepth: 8,
    // beforeBreadcrumb(breadcrumb: Breadcrumb) {
    // breadcrumb.data = redactBreadcrumbData(breadcrumb.data);
    // return breadcrumb;
    // },
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });

  const plugin = new LoglevelSentryPlugin(Sentry);
  plugin.install(log);
  enableSentryTracing(Sentry, [appConfig.api, appConfig.commonApiHost], []);
}

export async function setSentryEnabled(enabled: boolean): Promise<void> {
  const Sentry = await import("@sentry/vue");
  const client = Sentry.getCurrentHub().getClient();
  if (!client) return;

  client.getOptions().enabled = enabled;
}
